import { useMemo } from "react"
import { ImportPriceField, CsvContentSample, ProductPricesTemplateColumn } from "../../../../features/importer"
import { Column, FieldType } from "../../../../features/ui"
import { Data2 } from "../../../../features/data-types"

interface Props {
    priceField: ImportPriceField
}

export const PricesCsvSample = (props: Props) => {
    const { priceField } = props

    const columnLabel = useMemo(() => ProductPricesTemplateColumn[priceField], [priceField])
    const isYield = priceField === ImportPriceField.PRICE_YIELD

    const columns: Column[] = [
        {
            name: 'supplierCode',
            type: FieldType.TEXT,
            label: ProductPricesTemplateColumn.SUPPLIER_CODE
        },
        {
            name: 'product',
            type: FieldType.TEXT,
            label: ProductPricesTemplateColumn.PRODUCT
        },
        {
            name: 'supplier',
            type: FieldType.TEXT,
            label: ProductPricesTemplateColumn.SUPPLIER
        },
        {
            name: 'currentValue',
            type: FieldType.TEXT,
            label: `${columnLabel} Actual`
        },
        {
            name: 'newValue',
            type: FieldType.TEXT,
            label: columnLabel
        },
        {
            name: 'variation',
            type: FieldType.TEXT,
            label: 'Variación'
        }
    ]

    const rows: Data2[] = [
        {
            supplierCode: 'A',
            product: 'Producto A',
            supplier: 'Proveedor A',
            currentValue: isYield ? '30,00%' : '$ 1.000,00',
            newValue: isYield ? '35,00%' : '$ 1.100,00',
            variation: isYield ? '5,00%' : '10,00%'
        },
        {
            supplierCode: 'B',
            product: 'Producto B',
            supplier: 'Proveedor B',
            currentValue: isYield ? '25,00%' : '$ 2.000,00',
            newValue: '',
            variation: ''
        }
    ]

    return <CsvContentSample columns={columns} rows={rows} />
}
